import api from '../../api/region.api';
import * as types from "../types";

export const setRegions = (region) => {
  return { type: types.REGION_SET_LIST, data: region };
};

export function findRegionByState(state) {
  return (dispatch) => {
    return api.fetchRegions()
        .then(response => {
          dispatch(setRegions(response.result));
          return response.result;
        })
        .catch(error => Promise.reject(error));
  };
}
